export function normalizeDatasource(
  data: { dimension_value: null, id: number, name: string, value: string }[],
) {
  return data.map(({ name, dimension_value, value }) => ({
    name,
    value: dimension_value || value,
  }))
}
